var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":("json-" + _vm._uid)}},[_vm._v("Meta-Daten")]),_c('div',{ref:"editor"})])}
var staticRenderFns = []

export { render, staticRenderFns }